<template>
  <footer class="bg-footer py-3">
    <div class="container text-footer-color">
      © {{ currentYear }} {{selectedCompanyName}}. All rights reserved.
    </div>
  </footer>
</template>

<script>
import moment from 'moment-timezone'
import { SelectedSiteMixin } from '@/mixins/Site/SelectedSiteMixin'

export default {
  name: 'PageFooter',
  mixins: [SelectedSiteMixin],
  computed: {
    currentYear () {
      return moment().format('YYYY')
    }
  }
}
</script>
